import React from 'react';
import Typography from '@/components/primitives/typography';
import { CircleAlertIcon } from 'lucide-react';

import styles from './styles.module.scss';

interface Props {
  hide?: boolean;
  children?: React.ReactNode;
}

const ErrorText = (props: Props) => {
  const { hide = true } = props;

  if(hide) return (<></>);

  return (
    <div className={styles.container}>
      <CircleAlertIcon className={styles.icon} width={20} height={20} fill="white" />
      <Typography className={styles.text} size="small">{props.children}</Typography>
    </div>
  );
};

export default ErrorText;